import React from "react";
import {useDispatch, connect} from 'react-redux';
import { Paper } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import Tooltip from "@mui/material/Tooltip";
import ListAltIcon from '@mui/icons-material/ListAlt';
import GroupIcon from '@mui/icons-material/Groups';
import CloseIcon from '@mui/icons-material/Close';
import logo from '../images/elkh_logo.png';
import logo10gen from '../images/10gen_logo.png';
import hunrenLogo from "../images/hunrentech.png";

const mapStateToProps = (state) => {
    return {
        map: state.MapReducer
    }
}

const AttribPanel = (props) => {
    const dispatch = useDispatch();

    const [showPanel, setShowPanel] = React.useState(false);

    return <div>
    {
        !showPanel?(
            <Tooltip title="Open contribution panel">
            <IconButton style={{color: 'gray'}} onClick={()=>{setShowPanel(true)}} aria-label="open-attrib">
                <GroupIcon />
            </IconButton>
            </Tooltip>):''
    }

    <Paper elevation={10} style={{padding: 10, minWidth: 150, display:showPanel?'block':'none', paddingLeft: 16, paddingRight:16, maxHeight: 'calc(100vh - 90px)', overflowY: 'auto', borderRadius:10, backgroundColor:'#f0f0f0'}}>
        <IconButton style={{color:'gray', float:'right', marginRight:-8, marginTop:-8}} onClick={()=>{setShowPanel(false)}} aria-label="delete">
            <CloseIcon style={{width:20}} />
        </IconButton>

        <span>
            <h2>Contribution</h2>
            <p>The development was supported by the ELKH Proof of Concept 2021 tender (project manager: <a style={{textDecoration:'none', fontWeight:'bold', color:'#34A997'}} href="mailto:demetergg@gmail.com">Gábor Demeter</a>), the HAS RCH Lendület "Ten Generations" (project manager: <strong>Gergely Krisztián Horváth</strong>), the NKFIH (OTKA K 111 766) and the HUNRENTECH 2024-1 project.</p>
            <p><img src={logo} style={{height:40}} alt="ELKH logo" /><img src={logo10gen} style={{height:40}} alt="10 generáció logo" />&nbsp;&nbsp;&nbsp;<img src={hunrenLogo} alt="HUNRENTECH logo" style={{ height: 40 }} /></p>
            <p>Web development:<br /><a style={{textDecoration:'none', fontWeight:'bold', color:'#34A997'}} href="https://allum.digital/" target="_blank">Allum Digital</a></p>
            <p>The base maps were created by<br /><strong>Gábor Németh</strong><br />within the framework of the project NKFI 132723, "Square cadaster": Cadaster of the mapping and documentary material of the Hungarian cadastral survey, 1850–1918, managed by<br /><strong>T. Csaba Reisz</strong></p>
            <p>Project manager (GIStatistica Croatica, OTKA K 111 766):<br /><a style={{textDecoration:'none', fontWeight:'bold', color:'#34A997'}} href="mailto:demetergg@gmail.com">Gábor Demeter</a></p>
            <p>Data management:<br />
            <strong>Horbec, Ivana</strong> (Zagreb, Croatian Institute of History),<br />
            <strong>Katušić, Maja</strong> (Zagreb, Croatian Institute of History),<br />
            <a style={{textDecoration:'none', fontWeight:'bold', color:'#34A997'}} href="mailto:demetergg@gmail.com">Demeter, Gábor</a> (Budapest, HAS, Institute of History),<br />
            <strong>Veresegyházi, Béla</strong></p>

        {/* --- Creative Commons Licence --- */}
        <div style={{ marginTop: 16, paddingTop: 12, borderTop: "1px solid #ddd" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
            <a
              href="https://creativecommons.org/licenses/by-nc-sa/4.0/"
              target="_blank"
              rel="noreferrer"
              title="Creative Commons Attribution-NonCommercial-ShareAlike 4.0 International"
              style={{ display: "inline-flex", alignItems: "center" }}
            >
              <img
                src="https://licensebuttons.net/l/by-nc-sa/4.0/88x31.png"
                alt="CC BY-NC-SA 4.0"
                style={{ height: 31 }}
              />
            </a>
            <div style={{ fontSize: 13, lineHeight: 1.35, maxWidth: 720 }}>
              <strong>CC BY-NC-SA 4.0</strong> — You may share and adapt the material for <strong>non-commercial</strong> purposes,
              as long as you provide attribution, and you distribute adaptations under the <strong>same licence</strong>.
            </div>
          </div>

          <ul style={{ marginTop: 10, marginBottom: 10, paddingLeft: 18, fontSize: 13, lineHeight: 1.4 }}>
            <li><strong>BY</strong>: credit must be given to the creator.</li>
            <li><strong>NC</strong>: only non-commercial uses are permitted.</li>
            <li><strong>SA</strong>: adaptations must be shared under the same terms.</li>
          </ul>

          <div style={{ fontSize: 13, marginTop: 10 }}>
            <strong>Citation guidelines:</strong>
            <div style={{ marginTop: 6, whiteSpace: "pre-line" }}>
                GIStatistica Croatica<br />
                Project lead: Gábor Demeter.<br />
                Contributors include: Gábor Németh (base maps), István Papp (grid and raster mapping), Allum Digital (web development), and additional team members.<br />
                The project was supported by the ELKH Proof of Concept 2021 program, the HAS RCH Lendület “Ten Generations” programme, the NKFIH OTKA K 111 766 and the HUNRENTECH 2024-1 research project.<br />
                All materials are available under the Creative Commons CC BY-NC-SA 4.0 licence for non-commercial use only.
            </div>
          </div>

          <div style={{ fontSize: 13, marginTop: 12 }}>
            <strong>Required citation:</strong>
            <div
              style={{
                marginTop: 6,
                padding: 10,
                borderRadius: 8,
                background: "#fff",
                border: "1px solid #e0e0e0",
                fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace",
              }}
            >
              GIStatistica Croatica. Gábor Demeter et al. ELKH PoC 2021; HAS RCH Lendület Ten Generations; NKFIH OTKA K 111 766; HUNRENTECH 2024-1.
              Licensed under CC BY-NC-SA 4.0.
            </div>
          </div>
        </div>

        </span>

    </Paper>
    </div>
}

export default connect(mapStateToProps)(AttribPanel);